export default function ProvidedLimits() {
  return <div>Provided Limits</div>;
}
